import React, { useEffect, useState } from 'react';
import Navbar2 from '../Components/Navbar2';
import Footer2 from '../Components/Footer2';
import Aos from 'aos';
import { getCommunityAwards } from '../Common/apis';
import Loader from '../Loader/Loader.jsx';

function OurAwards() {
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });

    const fetchAwards = async () => {
      try {
        const res = await getCommunityAwards();
        setAwards(res.data || []);
      } catch (err) {
        console.error('Failed to fetch awards:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAwards();
  }, []);

  // Prepare for desktop layout
  const centerAward = awards[Math.floor(awards.length / 2)];
  const leftAwards = awards.slice(0, Math.floor(awards.length / 2));
  const rightAwards = awards.slice(Math.ceil(awards.length / 2));

  return (
    <>
      <div className="new-home overflow-hidden">
        <Navbar2 />

        {loading ? (
          <Loader />
        ) : (
          <div className="w-full">
            {/* Header Icons */}
            <div className="lg:mt-[84px] mt-[50px] lg:w-auto w-full">
              <div className="md:flex hidden flex-col pb-[24px] gap-[12px] ml-[-70px] items-start">
                <img
                  data-aos="flip-up"
                  src="/assets/media/gallery-icon-1.svg"
                  className="xl:h-auto lg:h-[53px] md:h-[53px] h-[53px]"
                  alt=""
                />
                <img
                  data-aos="flip-up"
                  src="/assets/media/awards.svg"
                  className="xl:h-auto lg:h-[53px] md:h-[53px] h-[53px]"
                  alt=""
                />
              </div>
              <div className="flex md:hidden flex-col lg:pb-[45px] pb-[16px] gap-[8px] ml-[-65px] items-start">
                <img
                  data-aos="flip-up"
                  src="/assets/media/mobile-gallery-icon-1.svg"
                  className="h-[53px]"
                  alt=""
                />
                <img
                  data-aos="flip-up"
                  src="/assets/media/mobile-awards.svg"
                  className="h-[53px]"
                  alt=""                  
                />
              </div>
            </div>

            {/* Mobile Grid View */}
            <div className='px-[50px] pt-[54px] pb-[80px] xl:hidden grid lg:grid-cols-3 grid-cols-2 gap-x-[36px] gap-y-[30px]'>
              {awards.map((award, i) => (
                <div key={award._id || i} className='flex flex-col items-center'>
                  <img src={award.image} alt={`award-${i}`} style={{width:"60px", height:"60px"}} />
                  <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">
                    {award.year}
                  </h6>
                  <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">
                    {award.awardName}
                  </p>
                  <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">
                    {award.place}
                  </p>
                </div>
              ))}
            </div>

            {/* Desktop Layout with Center & Side Awards */}
            <div className="relative w-full flex lg:px-0 px-[20px] lg:pb-[180px] pb-[100px] justify-center items-center">
              <img src="/assets/media/vector3.svg" alt="" />

              {/* Right Side Awards */}
              <div className="absolute right-[73px] xl:flex hidden flex-col gap-[40px]">
                {rightAwards.map((award, i) => (
                  <div key={award._id || i} className={`flex flex-col items-center ${i === 1 ? 'pl-[133px]' : ''}`}>
                    <img src={award.image} alt={`right-award-${i}`} style={{width:"60px", height:"60px"}} />
                    <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">
                      {award.year}
                    </h6>
                    <p className="pb-[4px] capitalize font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">
                      {award.awardName}
                    </p>
                    <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">
                      {award.place}
                    </p>
                  </div>
                ))}
              </div>

              {/* Left Side Awards */}
              <div className="absolute left-[73px] top-[199px] xl:flex hidden flex-col gap-[40px]">
                {leftAwards.map((award, i) => (
                  <div key={award._id || i} className={`flex flex-col items-center ${i === 0 ? 'pr-[133px]' : ''}`}>
                    <img src={award.image} alt={`left-award-${i}`} style={{width:"60px", height:"60px"}} />
                    <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">
                      {award.year}
                    </h6>
                    <p className="pb-[4px] capitalize font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">
                      {award.awardName}
                    </p>
                    <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">
                      {award.place}
                    </p>
                  </div>
                ))}
              </div>

              {/* Center Award */}
              {centerAward && (
                <div className="xl:flex hidden absolute top-[-180px] left-[50%] translate-x-[-50%] flex-col items-center">
                  <img src={centerAward.image} alt="center-award" style={{width:"60px", height:"60px"}} />
                  <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">
                    {centerAward.year}
                  </h6>
                  <p className="pb-[4px] capitalize font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">
                    {centerAward.awardName}
                  </p>
                  <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">
                    {centerAward.place}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}


        {/* <div className="w-full">
          <div className='lg:mt-[84px] mt-[50px] lg:w-auto w-full'>
            <div className='md:flex hidden flex-col pb-[24px] gap-[12px] ml-[-70px] items-start'>
              <img data-aos="flip-up" src="/assets/media/gallery-icon-1.svg" className='xl:h-auto lg:h-[53px] md:h-[53px] h-[53px]' alt="" />
              <img data-aos="flip-up" src="/assets/media/awards.svg" className='xl:h-auto lg:h-[53px] md:h-[53px] h-[53px]' alt="" />
            </div>
            <div className='flex md:hidden flex-col lg:pb-[45px] pb-[16px] gap-[8px] ml-[-65px] items-start'>
              <img data-aos="flip-up" src="/assets/media/mobile-gallery-icon-1.svg" className='h-[53px]' alt="" />
              <img data-aos="flip-up" src="/assets/media/mobile-awards.svg" className='h-[53px]' alt="" />
            </div>
          </div>
          <div className='px-[50px] pt-[54px] pb-[80px] xl:hidden grid lg:grid-cols-3 grid-cols-2 gap-x-[36px] gap-y-[30px]'>
            <div className='flex flex-col items-center'>
              <img src="/assets/media/trophy.svg" alt="" />
              <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
              <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
              <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
            </div>
            <div className='flex flex-col items-center'>
              <img src="/assets/media/trophy.svg" alt="" />
              <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
              <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
              <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
            </div>
            <div className='flex flex-col items-center'>
              <img src="/assets/media/trophy.svg" alt="" />
              <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
              <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
              <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
            </div>
            <div className='flex flex-col items-center'>
              <img src="/assets/media/trophy.svg" alt="" />
              <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
              <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
              <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
            </div>
            <div className='flex flex-col items-center'>
              <img src="/assets/media/trophy.svg" alt="" />
              <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
              <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
              <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
            </div>
              <div className='flex flex-col items-center'>
                <img src="/assets/media/trophy.svg" alt="" />
                <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
                <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
                <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
              </div>
          </div>
          <div className="relative w-full flex lg:px-0 px-[20px] lg:pb-[180px] pb-[100px] justify-center items-center">
            <img src="/assets/media/vector3.svg" alt="" />
            <div className='absolute right-[73px] xl:flex hidden flex-col gap-[40px]'>
              <div className='flex flex-col items-center'>
                <img src="/assets/media/trophy.svg" alt="" />
                <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
                <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
                <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
              </div>
              <div className='flex flex-col items-center pl-[133px]'>
                <img src="/assets/media/trophy.svg" alt="" />
                <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
                <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
                <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
              </div>
              <div className='flex flex-col items-center'>
                <img src="/assets/media/trophy.svg" alt="" />
                <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
                <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
                <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
              </div>
            </div>
            <div className='absolute left-[73px] top-[199px] xl:flex hidden flex-col gap-[40px]'>
              <div className='flex flex-col items-center pr-[133px]'>
                <img src="/assets/media/trophy.svg" alt="" />
                <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
                <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
                <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
              </div>
              <div className='flex flex-col items-center'>
                <img src="/assets/media/trophy.svg" alt="" />
                <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
                <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
                <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
              </div>
            </div>
            <div className='xl:flex hidden absolute top-[-180px] left-[50%] translate-x-[-50%] flex-col items-center'>
              <img src="/assets/media/trophy.svg" alt="" />
              <h6 className="pt-[16px] text-center font-roboto font-[700] text-[24px] text-[#FFFFFF] pb-[4px]">2024</h6>
              <p className="pb-[4px] font-[700] font-roboto text-[16px] text-[#FFFFFF] text-center">India’s Rising Stars</p>
              <p className="font-[500] font-roboto text-[12px] uppercase text-[#FFFFFF] opacity-[60%]">MUMBAI</p>
            </div>
          </div>
        </div> */}

        <Footer2 />
      </div>
    </>
  );
}

export default OurAwards;
